import APITemplate from '@api/APITemplate'
import { diffTimeMinutes } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { disclaimer } from '@modules/global/constants/URL'

class APIGlobalDisclaimer extends APITemplate {
  constructor() {
    super()

    this.reqCarregar = null
  }

  async carregar(forceUpdate = false) {
    if (this.reqCarregar) {
      return this.reqCarregar
    }
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['global/disclaimerLastUpdate'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        return store.getters['global/disclaimer']
      }
    }

    if (store.getters['global/disclaimerLoading']) {
      return store.getters['global/disclaimer']
    }

    store.dispatch('global/setDisclaimerLoading', true)

    this.reqCarregar = con.get(disclaimer.manage)
    const r = await this.reqCarregar

    if (r && r.status === 200) {
      store.dispatch('global/setDisclaimer', r.value || [])
    } else {
      store.dispatch('global/setDisclaimer', [])
    }

    store.dispatch('global/setDisclaimerLoading', false)

    this.reqCarregar = null

    return r || {}
  }
}

const apiGlobalDisclaimer = new APIGlobalDisclaimer()
export { apiGlobalDisclaimer }
